import { render, staticRenderFns } from "./IpAddressWhitelistComponent.vue?vue&type=template&id=684acdde&scoped=true&"
import script from "./IpAddressWhitelistComponent.vue?vue&type=script&lang=js&"
export * from "./IpAddressWhitelistComponent.vue?vue&type=script&lang=js&"
import style0 from "./IpAddressWhitelistComponent.vue?vue&type=style&index=0&id=684acdde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684acdde",
  null
  
)

export default component.exports